import { getConfiguration, verifyExtend } from "./extend-utils.js";
import { initProductOffer } from "./extend-product.js";
import { initCartOffer } from "./extend-cart.js";

function initAftermarket() {
    try {
        verifyExtend();

        // Get params from URL
        const params = (new URL(document.location)).searchParams;

        // Check if leadToken or leadtoken is in the URL
        let leadToken = params.get('leadToken')
            ? params.get('leadToken')
            : params.get('leadtoken');

        if (leadToken) {
            Extend.aftermarketModal.open({
                leadToken: leadToken,
                onClose: function (plan, product, quantity) {
                    if (plan && product) {
                        ExtendShopify.addPlanToCart({
                            plan: plan,
                            product: product,
                            leadToken: leadToken,
                            quantity: quantity || 1
                        }, function () {
                            location = '/cart'
                        })
                    }
                }
            });
        }
    } catch (error) {
        throw new ExtendError( error.message);
    }
}

(() => {
    try {
        const storeId = 'b282e9cb-d344-4688-bbbc-1772ab8de15d';
        const environment = 'production';

        window.Extend.config({ storeId, environment});

        const config = getConfiguration();

        if (config.aftermarketModalEnabled)
            initAftermarket();

        if (config.atcOfferEnabled || config.offerModalEnabled || config.pdpOfferEnabled)
            initProductOffer();

        if (config.cartOfferEnabled || config.cartSPEnabled || config.sideCartOfferEnabled)
            initCartOffer();
    } catch (err) {
        if (Boolean(sessionStorage.getItem('extend.debug')))
            console.error(err);
    }
})();